export default "__VITE_ASSET__BGNAIF3e__"